'use client'
import React, { useRef, useEffect } from 'react'
import { gsap } from 'gsap'

interface MagnitizeProps {
  children: React.ReactNode
  intensity?: number // The intensity of the magnet effect
  className?: string
  ref?: React.Ref<HTMLDivElement>
}

const Magnitize: React.FC<MagnitizeProps> = ({
  children,
  className,
  intensity = 100,
  ref,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const wrapper = wrapperRef.current

    if (!wrapper) return

    const handleMouseMove = (e: MouseEvent) => {
      const rect = wrapper.getBoundingClientRect()
      const centerX = rect.left + rect.width / 2
      const centerY = rect.top + rect.height / 2
      const deltaX = (e.clientX - centerX) / intensity
      const deltaY = (e.clientY - centerY) / intensity

      gsap.to(wrapper, {
        x: deltaX,
        y: deltaY,
        duration: 0.3,
        ease: 'power2.out',
      })
    }

    const handleMouseLeave = () => {
      gsap.to(wrapper, {
        x: 0,
        y: 0,
        duration: 0.3,
        ease: 'power2.out',
      })
    }

    wrapper.addEventListener('mousemove', handleMouseMove)
    wrapper.addEventListener('mouseleave', handleMouseLeave)

    return () => {
      wrapper.removeEventListener('mousemove', handleMouseMove)
      wrapper.removeEventListener('mouseleave', handleMouseLeave)
    }
  }, [intensity])

  return (
    <div ref={wrapperRef} className={`${className} inline-block`}>
      {children}
    </div>
  )
}

export default Magnitize
